import React, { useState, useEffect } from 'react';
import { getFirestore, collection, query, orderBy, onSnapshot, getDocs, where, documentId } from 'firebase/firestore';

const SalesTab = () => {
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(true);
  const db = getFirestore();

  useEffect(() => {
    const q = query(collection(db, 'tips'), orderBy('timestamp', 'desc'));
    
    const unsubscribe = onSnapshot(q, async (snapshot) => {
      if (snapshot.empty) {
        setSales([]);
        setLoading(false);
        return;
      }
      
      const tipsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      // Hydration Logic
      const songIds = [...new Set(tipsData.map(t => t.songId).filter(Boolean))];
      const artistIds = [...new Set(tipsData.map(t => t.artistId).filter(Boolean))];

      const songMap = {};
      const artistMap = {};

      if (songIds.length > 0) {
        const songsSnap = await getDocs(query(collection(db, 'songs'), where(documentId(), 'in', songIds)));
        songsSnap.forEach(doc => songMap[doc.id] = doc.data().title);
      }
      if (artistIds.length > 0) {
        const artistsSnap = await getDocs(query(collection(db, 'artist_accounts'), where(documentId(), 'in', artistIds)));
        artistsSnap.forEach(doc => artistMap[doc.id] = doc.data().artistName);
      }
      
      setSales(tipsData.map(tip => ({
        ...tip,
        songTitle: songMap[tip.songId] || 'Unknown Song',
        artistName: artistMap[tip.artistId] || 'Unknown Artist'
      })));
      setLoading(false);
    });

    return () => unsubscribe();
  }, [db]);

  if (loading) return <div className="p-10 text-center text-gray-400">Loading ledger...</div>;

  return (
    <div className="p-6">
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
        <div className="grid grid-cols-4 gap-4 p-4 bg-gray-50 border-b text-xs font-black uppercase tracking-widest text-gray-400">
          <span>Artist</span>
          <span>Song</span>
          <span>Date / Time</span>
          <span className="text-right">Amount (AUD)</span>
        </div>
        
        {sales.map(sale => (
          <div key={sale.id} className="grid grid-cols-4 gap-4 p-4 border-b hover:bg-green-50 transition-colors items-center">
            <span className="font-bold text-slate-700">{sale.artistName}</span>
            <span className="text-slate-600 italic">"{sale.songTitle}"</span>
            <span className="text-gray-500 text-sm">
              {sale.timestamp?.toDate().toLocaleString() || 'N/A'}
            </span>
            <span className="font-mono font-black text-green-600 text-right text-lg">
              ${sale.tipAmountAUD?.toFixed(2)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SalesTab;